import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import ArticleCard from "@/components/ArticleCard";
import CTABand from "@/components/CTABand";
import { Input } from "@/components/ui/input";
import api from "@/lib/api";

export default function Insights() {
  const [all, setAll] = useState([]);
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("all");

  useEffect(() => {
    api.get("/public/articles").then((r) => setAll(r.data)).catch(() => {});
  }, []);

  const categories = ["all", ...Array.from(new Set(all.map((a) => a.category)))];
  const filtered = all.filter((a) => {
    const matchCat = cat === "all" || a.category === cat;
    const t = q.toLowerCase();
    const matchQ = !t || a.title.toLowerCase().includes(t) || (a.excerpt || "").toLowerCase().includes(t);
    return matchCat && matchQ;
  });
  const featured = filtered[0];
  const rest = filtered.slice(1);

  return (
    <>
      <Seo title="Insights & Resources | ApexPath"
        description="Clear, practical and up-to-date information to help you understand UK immigration and stay ahead of the latest changes." />
      <PageHero
        crumbs={[{ label: "Home", to: "/" }, { label: "Insights" }]}
        eyebrow="Insights & Resources"
        title="Insights &" highlight="Resources"
        image="/images/insights-hero.jpg"
        subtitle="Clear, practical and up-to-date information to help you understand UK immigration, make informed decisions and stay ahead of the latest changes.">
        <div className="relative max-w-xl">
          <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
          <Input
            data-testid="insights-search-input"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search articles, topics or keywords..."
            className="h-12 rounded-full border-0 bg-white pl-11 text-navy shadow-lg"
          />
        </div>
      </PageHero>

      <section className="bg-cream py-14">
        <div className="container-x">
          <div className="mb-8 flex flex-wrap gap-2">
            {categories.map((c) => (
              <button
                key={c}
                data-testid={`insights-filter-${c}`}
                onClick={() => setCat(c)}
                className={`rounded-full border px-4 py-1.5 text-sm font-medium transition-colors ${
                  cat === c ? "border-navy bg-navy text-white" : "border-slate-300 bg-white text-slate-600 hover:border-navy"
                }`}
              >
                {c === "all" ? "All Articles" : c}
              </button>
            ))}
          </div>

          {filtered.length === 0 ? (
            <p className="py-12 text-center text-slate-500" data-testid="insights-empty">No articles match your search.</p>
          ) : (
            <>
              {featured && cat === "all" && !q && (
                <div className="mb-8">
                  <ArticleCard article={featured} featured />
                </div>
              )}
              <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                {(cat === "all" && !q ? rest : filtered).map((a) => <ArticleCard key={a.id} article={a} />)}
              </div>
            </>
          )}
        </div>
      </section>

      <CTABand />
    </>
  );
}
